import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _typeof from "/data/devops/workspace/node_modules/@babel/runtime/helpers/esm/typeof";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';
import CheckboxCom from '@/views/components/importerFormCom/checkboxCom.vue';
import ConfirmationLetterCom from '@/views/components/importerFormCom/confirmationLetterCom.vue';
import SelectCom from '@/views/components/importerFormCom/selectCom.vue';
import UploadCom from '@/views/components/importerFormCom/uploadCom.vue';
import RadioCom from '@/views/components/importerFormCom/radioCom.vue';
import StatementConfirmCom from '@/views/components/importerFormCom/statementConfirm.vue';

var ModalForm = function (_super) {
  __extends(ModalForm, _super);

  function ModalForm() {
    var _a;

    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.loading = false;
    _this.formData = {};
    _this.warehouseList = [];
    _this.formControlMap = (_a = {}, _a[_this.$enum.warehouse.ImporterFormControlType.INPUT] = 'my-input', _a[_this.$enum.warehouse.ImporterFormControlType.TEXTAREA] = 'a-input', _a[_this.$enum.warehouse.ImporterFormControlType.SELECT] = 'select-com', _a[_this.$enum.warehouse.ImporterFormControlType.SELECT_MULTIPLE] = 'select-com', _a[_this.$enum.warehouse.ImporterFormControlType.ATTCHMENT] = 'upload-com', _a[_this.$enum.warehouse.ImporterFormControlType.RADIO] = 'radio-com', _a[_this.$enum.warehouse.ImporterFormControlType.SINGLE_CHECKBOX] = 'confirmation-letter-com', _a[_this.$enum.warehouse.ImporterFormControlType.STATEMENT_CONFIRM] = 'statement-confirm-com', _a);
    _this.filedConfigList = [];
    _this.formDataRule = {};
    return _this;
  }

  ModalForm.prototype.onVisibleChange = function (value) {
    return __awaiter(this, void 0, void 0, function () {
      var data, _a, formData, formDataRef;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!(value && this.cvId !== undefined && this.cvId !== '')) return [3, 3];
            return [4, this.queryImporterDetail({
              id: this.cvId
            })];

          case 1:
            data = _b.sent();
            _a = this;
            return [4, this.queryImporterFieldConfig({
              warehouse_code: data.warehouse_code
            })];

          case 2:
            _a.filedConfigList = _b.sent();
            formData = this.createFormData();
            formData.cv_id = this.cvId, this.formData = this.mergeDetailDataToFormData(formData, data);
            this.formDataRule = this.createRules();
            return [3, 4];

          case 3:
            this.formData = {};
            this.filedConfigList = [];
            formDataRef = this.$refs.formDataRef;
            formDataRef && formDataRef.resetFields();
            _b.label = 4;

          case 4:
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.mergeDetailDataToFormData = function (formData, data) {
    for (var key in formData) {
      if (data[key] !== undefined && data[key] !== null) {
        if (_typeof(data[key]) === 'object' && !(data[key] instanceof Array)) {
          this.mergeDetailDataToFormData(formData[key], data[key]);
        } else {
          formData[key] = data[key];
        }
      }
    }

    return formData;
  };

  ModalForm.prototype.createRules = function () {
    var _this = this;

    var formDataRule = {
      warehouse_code: [{
        required: true,
        message: this.t('请选择仓库')
      }]
    };
    this.filedConfigList.forEach(function (item) {
      var ruleList = [];

      if (item.is_require) {
        if (_this.isMultiple(item.value_type)) {
          ruleList.push({
            type: 'array',
            required: true,
            message: _this.t(item.value) + _this.t('必填')
          });
        } else if (item.value_type === _this.$enum.warehouse.ImporterFormControlType.SINGLE_CHECKBOX) {
          ruleList.push({
            required: true,
            type: 'boolean',
            message: _this.t('请勾选')
          });
        } else {
          ruleList.push({
            required: true,
            message: _this.t(item.value) + _this.t('必填'),
            trigger: 'change'
          });
        }
      }

      item.input_limit_list.forEach(function (rule) {
        var message = _this.$util.getImporterInputLimitTipMessage(rule.code);

        if (rule.regular) {
          try {
            ruleList.push({
              pattern: new RegExp(rule.regular),
              message: message
            });
          } catch (e) {
            var error = e;
            console.error(error);
          }
        } else if (rule.code === _this.$enum.warehouse.InputLimitRule.FIRST_TWO_CHARACTERS_MUST_BE_REGISTERED_COUNTRY_CODE) {
          ruleList.push({
            validator: function validator(ruleItem, value, callback) {
              if (value && String(value).substr(0, 2).toUpperCase() === _this.formData.coc_registration) {
                callback();
              } else {
                callback(new Error(message));
              }
            }
          });
        }
      });

      if (item.value_type === _this.$enum.warehouse.ImporterFormControlType.SINGLE_CHECKBOX) {
        ruleList.push({
          required: true,
          type: 'boolean',
          message: _this.t('请勾选“我已阅读并同意《相关服务条款》”')
        });
      }

      if (item.key_option_list && item.key_option_list.length) {
        formDataRule[item.filed + ".value"] = ruleList;
      } else {
        formDataRule[item.filed] = ruleList;
      }
    });
    return formDataRule;
  };

  ModalForm.prototype.createFormData = function () {
    var _this = this;

    var formData = {
      warehouse_code: this.formData.warehouse_code,
      cv_id: this.formData.cv_id
    };
    this.filedConfigList.forEach(function (item) {
      var isMultiple = _this.isMultiple(item.value_type);

      if (item.key_option_list && item.key_option_list.length) {
        var code = item.key_option_list[0].code;
        formData[item.filed] = {
          code: code,
          value: isMultiple ? [] : undefined
        };
        return;
      }

      if (isMultiple) {
        formData[item.filed] = [];
      } else {
        formData[item.filed] = '';
      }
    });
    return formData;
  };

  ModalForm.prototype.queryImporterDetail = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.queryImportDetail(param)];

          case 1:
            data = _a.sent().data;
            return [2, data];
        }
      });
    });
  };

  ModalForm.prototype.queryImporterFieldConfig = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.queryImporterFieldConfig(param)];

          case 1:
            data = _a.sent().data;
            return [2, data.list];
        }
      });
    });
  };

  ModalForm.prototype.getExtList = function (list) {
    return list.map(function (item) {
      return item.value;
    });
  };

  ModalForm.prototype.isMultiple = function (value) {
    return [this.$enum.warehouse.ImporterFormControlType.CHECKBOX, this.$enum.warehouse.ImporterFormControlType.SINGLE_CHECKBOX].indexOf(value) > 1;
  };

  ModalForm.prototype.addImporter = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.addImporterNew(param)];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ModalForm.prototype.editImporter = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.editImporterNew(param)];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ModalForm.prototype.handleOk = function () {
    var _this = this;

    var com = this.$refs.formDataRef;
    com.validate(function (valid, field) {
      return __awaiter(_this, void 0, Promise, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!valid) {
                return [2];
              }

              if (this.isCopy) {
                this.formData.cv_id = undefined;
              }

              if (!this.formData.cv_id) return [3, 2];
              return [4, this.editImporter(this.formData)];

            case 1:
              _a.sent();

              return [3, 4];

            case 2:
              return [4, this.addImporter(this.formData)];

            case 3:
              _a.sent();

              _a.label = 4;

            case 4:
              this.visible = false;
              this.$message.success(this.t('操作成功'));
              typeof this.onSuccess === 'function' && this.onSuccess();
              return [2];
          }
        });
      });
    });
  };

  ModalForm.prototype.handleChangeWarehouse = function (val) {
    return __awaiter(this, void 0, Promise, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!val) {
              this.filedConfigList = [];
              return [2];
            }

            _a = this;
            return [4, this.queryImporterFieldConfig({
              warehouse_code: val
            })];

          case 1:
            _a.filedConfigList = _b.sent();
            this.formData = this.createFormData();
            this.formDataRule = this.createRules();
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.handleValidateField = function (field) {
    var formDataRef = this.$refs.formDataRef;
    formDataRef.validateField(field, function () {});
  };

  ModalForm.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList({
              is_open_only: true
            })];

          case 1:
            data = _a.sent().data;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.onModalVisibleChange = function () {
    if (this.visible) {
      this.queryWarehouseList();
    }
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], ModalForm.prototype, "cvId", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], ModalForm.prototype, "isCopy", void 0);

  __decorate([Prop({
    type: Function,
    "default": function _default() {
      return function () {};
    }
  })], ModalForm.prototype, "onSuccess", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], ModalForm.prototype, "onVisibleChange", null);

  __decorate([loading('loading')], ModalForm.prototype, "addImporter", null);

  __decorate([loading('loading')], ModalForm.prototype, "editImporter", null);

  __decorate([Watch('visible')], ModalForm.prototype, "onModalVisibleChange", null);

  ModalForm = __decorate([Component({
    components: {
      CheckboxCom: CheckboxCom,
      ConfirmationLetterCom: ConfirmationLetterCom,
      SelectCom: SelectCom,
      UploadCom: UploadCom,
      RadioCom: RadioCom,
      StatementConfirmCom: StatementConfirmCom
    }
  })], ModalForm);
  return ModalForm;
}(Vue);

export default ModalForm;